
export default function Portfolio() {
  return (
    <section id="portfolio" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-2">
            <span className="text-gray-900">Our</span>
            <span className="text-teal-500"> Gallery</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          <div className="relative h-[600px] rounded-3xl overflow-hidden shadow-lg group">
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
              style={{
                backgroundImage: 'url(https://public.readdy.ai/ai/img_res/907ca17f9b51cf15d03b14d424ab01d4.jpg)',
              }}
            ></div>
            <div className="absolute bottom-6 left-6 bg-black/60 backdrop-blur-sm px-4 py-2 rounded-lg">
              <span className="text-white text-sm font-medium">Treatment Room</span>
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <div className="relative h-[290px] rounded-3xl overflow-hidden shadow-lg group">
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
                style={{
                  backgroundImage: 'url(https://readdy.ai/api/search-image?query=Serene%20spa%20relaxation%20area%20with%20comfortable%20lounge%20chairs%2C%20soft%20cushions%2C%20and%20warm%20ambient%20lighting.%20The%20space%20features%20natural%20materials%20including%20bamboo%2C%20stone%2C%20and%20wood%20with%20green%20plants%20creating%20a%20peaceful%20atmosphere.%20Color%20palette%20of%20warm%20beige%2C%20cream%2C%20and%20soft%20earth%20tones.%20Professional%20spa%20interior%20photography%20with%20inviting%20and%20tranquil%20ambiance%2C%20minimalist%20design%20with%20simple%20clean%20background.&width=600&height=400&seq=portfolio-lounge-001&orientation=landscape)',
                }}
              ></div>
              <div className="absolute bottom-4 left-4 bg-black/60 backdrop-blur-sm px-4 py-2 rounded-lg">
                <span className="text-white text-sm font-medium">Relaxation Area</span>
              </div>
            </div>

            <div className="relative h-[290px] rounded-3xl overflow-hidden shadow-lg group">
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
                style={{
                  backgroundImage: 'url(https://readdy.ai/api/search-image?query=Professional%20spa%20therapist%20performing%20gentle%20facial%20treatment%20on%20relaxed%20client%20in%20peaceful%20treatment%20room.%20Soft%20natural%20lighting%20creates%20a%20calming%20atmosphere%20with%20warm%20tones.%20The%20scene%20shows%20premium%20skincare%20products%2C%20fresh%20flowers%2C%20and%20elegant%20spa%20setting%20with%20simple%20beige%20and%20cream%20background.%20Professional%20spa%20service%20photography%20emphasizing%20luxury%20wellness%20experience%20and%20expert%20care%20with%20minimalist%20composition.&width=600&height=400&seq=portfolio-treatment-001&orientation=landscape)',
                }}
              ></div>
              <div className="absolute bottom-4 left-4 bg-black/60 backdrop-blur-sm px-4 py-2 rounded-lg">
                <span className="text-white text-sm font-medium">Treatment Scene</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
